import {
  GlobalActionConstants as C,
  makeActionCreator,
} from './types/redux';

const create = makeActionCreator<C>();

export const notifyHttpUnauthorized = create<unknown>(C.HTTP_UNAUTHORIZED_NOTIFY);
export const dismissHttpUnauthorized = create<unknown>(C.HTTP_UNAUTHORIZED_DISMISS);
